import formDictionarySource from "./form_dictionary.json";

export type RocRequirementTestingEntry = {
    testing_procedures?: string;
    reporting_instructions?: string[];
};

export type RocRequirementEntry = {
    title?: string;
    subtitle?: string;
    category?: string;
    section_category?: string;
    section_requirement?: string;
    section_subtitle?: string;
    section_number?: string;
    section_description?: string;
    section_testing?: Record<string, RocRequirementTestingEntry>;
    free_trial_enabled?: boolean;
};

export type RocFormSection = {
    nav_title?: string;
    title?: string;
    title_number?: string;
    pdf_layout?: string;
    requirements?: Record<string, RocRequirementEntry>;
};

export type RocFormDictionary = Record<string, RocFormSection>;

export const rocFormDictionary = formDictionarySource as RocFormDictionary;
